import { render, staticRenderFns } from "./TopicAdder.vue?vue&type=template&id=d23d9b68&scoped=true"
import script from "./TopicAdder.vue?vue&type=script&lang=js"
export * from "./TopicAdder.vue?vue&type=script&lang=js"
import style0 from "./TopicAdder.vue?vue&type=style&index=0&id=d23d9b68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23d9b68",
  null
  
)

export default component.exports